import * as React from "react";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { PensionBase } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/PensionBase";
import { DrawdownModel } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/DrawdownModel";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { processTypeEnum } from "../../../Common/Resource/Contents";
import IncomeRequired from "../../../Common/SIPP/IncomePaymentDetails/IncomeRequired";
import RegularIncomePayment from "../../../Common/SIPP/IncomePaymentDetails/RegularIncomePayment";
import {
    incomePaymentDetailsLabels,
    incomePaymentDetailsMessages,
} from "../../../Common/SIPP/IncomePaymentDetails/Resource/Content";
import { DrawdownType } from "../../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { ChooseAssetsToSellAssets } from "../../../Common/SIPP/DrawdownDetails/Store/DrawdownCalculationStoreStatic";

interface IRegularIncomePaymentDetailsProps extends IProcessComponentProps {
    data: DrawdownModel;
    pensionBase: PensionBase;
    sellableAssets?: ChooseAssetsToSellAssets[];
}

interface IRegularIncomePaymentDetailsState { }

export class RegularIncomePaymentDetails extends ProcessComponent<
    IRegularIncomePaymentDetailsProps,
    IRegularIncomePaymentDetailsState
> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    private getIncomeProps = (data, onChange) => {
        return {
            data: data?.Income,
            onChange: (changes) => this.onDataChange(onChange, changes, data, "Income"),
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: this.props.showErrorMsgPopUp,
            isReview: this.props.isReview,
        };
    };

    public render(): JSX.Element {
        const { data, onChange, pensionBase, sellableAssets } = this.props;
        const drawdownType = data?.DrawdownType;
        return (
            <>
                <RadiosEditor
                    cssWrapper="rg-inline mb-16"
                    label={incomePaymentDetailsLabels.taxableIncomeRequiredInAddition}
                    selected={data?.Income?.TaxableIncomeRequiredInAddition || false}
                    options={[true, false]}
                    getText={(v) => (v ? "Yes" : "No")}
                    onChange={(v) => {
                        this.onDataChange(
                            (changes) => this.onDataChange(onChange, changes, data, "Income"),
                            { TaxableIncomeRequiredInAddition: v },
                            data.Income
                        );
                        if (!v) {
                            this.onDataChange(
                                (changes) => this.onDataChange(onChange, changes, data, "Income"),
                                { IncomeDisinvestmentAllocations: [], TaxableIncomeRequiredInAddition: v },
                                data.Income
                            );
                        }
                    }}
                />
                {data?.Income?.TaxableIncomeRequiredInAddition && (
                    <>
                        <IncomeRequired
                            {...this.getIncomeProps(data, onChange)}
                            labels={incomePaymentDetailsLabels}
                            messages={incomePaymentDetailsMessages}
                            drawdownType={drawdownType}
                            regularCrystalDifferentInital={
                                data?.RegularCrystallisationDetails?.HasADifferentInitialAmount
                            }
                            regularCrystallisationDetails={data?.RegularCrystallisationDetails}
                            pensionBase={pensionBase}
                            isITFC={false}
                            processType={processTypeEnum.TakePensionBenefits}
                        />
                        <RegularIncomePayment
                            {...this.getIncomeProps(data, onChange)}
                            labels={incomePaymentDetailsLabels}
                            messages={incomePaymentDetailsMessages}
                            drawdownType={drawdownType}
                            regularCrystallisationDetails={data?.RegularCrystallisationDetails}
                            shouldHidePaymentMethod={drawdownType === DrawdownType.Regular}
                            pensionBase={pensionBase}
                            processType={processTypeEnum.TakePensionBenefits}
                            isITFC={false}
                            subaccountHierarchyid={getQueryParameters()["subaccounthierarchyid"]}
                            sellableAssets={sellableAssets}
                        />
                    </>
                )}
            </>
        );
    }
}
